import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { URLS } from "../_config";
import Button from "../components/elements/button";
import Container from "../components/Container";

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("errors");

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate(URLS.DASHBOARD);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Container>
        <div className="max-w-md w-full space-y-8 text-center mx-auto">
        <div>
          <div className="mx-auto flex items-center justify-center h-24 w-24 rounded-full bg-red-100">
            <svg
              className="h-12 w-12 text-red-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            {t("unauthorized.title")}
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            {t("unauthorized.message")}
          </p>
          <p className="mt-1 text-sm text-gray-500">
            {t("unauthorized.adminContact")}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={handleGoBack}>{t("unauthorized.goBack")}</Button>
          <Button onClick={handleGoHome}>{t("unauthorized.goHome")}</Button>
        </div>
        </div>
      </Container>
    </div>
  );
};

export default Unauthorized;
